export default __webpack_public_path__ + "static/media/edit.5a58ba64.svg";